import { render, staticRenderFns } from "./purchaseInstallments.vue?vue&type=template&id=b1ed80ec&"
import script from "./purchaseInstallments.vue?vue&type=script&lang=js&"
export * from "./purchaseInstallments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports